// extracted by mini-css-extract-plugin
export default {"latestNews":"LatestNews_latestNews__efXVv"};